<template>
    <Page withNavbar>
        <header>
            <ProfilePicture :src="user.picture" :color="config.COLOR_PRIMARY"/>
            <h3>
                {{ user.displayName }}
            </h3>
            <h5 v-if="user.email">
                {{ user.email }}
            </h5>
        </header>
        <nav>
            <router-link :to="{ name: 'profile.about' }" exact>
                {{ config.PROFILE_INFO }}
            </router-link>
            <router-link v-if="showUserVideos" :to="{ name: 'profile.videos' }" exact>
                {{ config.PROFILE_VIDEOS }}
            </router-link>
        </nav>
        <router-view/>
    </Page>
</template>
<script>
import { SolutionConsumer, UserConsumer } from '../../mixins';
import { Page, ProfilePicture } from '../../components/mobile';

export default {
    name: 'Profile',
    components: {
        Page, ProfilePicture,
    },
    mixins: [SolutionConsumer, UserConsumer],
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/mixins';
@import '../../assets/scss/colors';

header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 20px;
    background-color: $white;

    > h3 {
        margin: 20px 0 0 0;
    }

    > h5 {
        font-weight: normal;
        margin: 0;
    }
}

nav {
    display: flex;
    border-bottom: 1px solid $grey-lightest;
    background-color: $white;

    > a {
        @include a-reset();
        color: $grey-light;
        text-transform: uppercase;
        padding: 20px;
        white-space: nowrap;
        flex: 1;
        text-align: center;
        // Merge border
        margin-bottom: -1px;

        &.router-link-active {
            color: $grey-darkest;
            border-bottom: 2px solid $grey-darkest;
        }
    }
}
</style>
